var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var StatusChangeSettingsModalController = /** @class */ (function (_super) {
            __extends(StatusChangeSettingsModalController, _super);
            function StatusChangeSettingsModalController($scope, workflowService, processConfigId, workflowBlock, isReadonly, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.scope = $scope;
                _this.scope.workflowBlock = workflowBlock;
                _this.scope.isReadonly = isReadonly;
                workflowService.getStatuses(processConfigId).then(function (statusGroupsDto) {
                    _this.scope.dropDownOptions = Enumerable.from(statusGroupsDto.statusGroups).where(function (i) { return i.id !== workflowBlock.statusChangeDto.currentStatusCodeId; }).toArray();
                });
                return _this;
            }
            return StatusChangeSettingsModalController;
        }(controllers.BaseModalController));
        controllers.StatusChangeSettingsModalController = StatusChangeSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('StatusChangeSettingsModalController', ['$scope', 'workflowService', 'processConfigId', 'workflowBlock', 'isReadonly', 'close']);
